import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-578b66fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-part-a-declaration" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-3 mb-3" }, "Declaration", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 declarations mt-4" }, [
  /*#__PURE__*/_createTextVNode(" By clicking “Submit” I declare that:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" The contents of this submission are true and correct; and"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" I have read the "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "link",
    href: "https://www.lawsociety.com.au/privacy-policy/personal-information-collection-notice",
    target: "_blank"
  }, "Personal Information Collection Notice"),
  /*#__PURE__*/_createTextVNode(" and consent to The Law Society of New South Wales collection, use and disclosure of information in accordance with that Notice; and ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 declarations mt-4" }, "The Law Society has been advised of all known instances of non-compliance or suspected non-compliance with the provisions of the Uniform Law and the Uniform Rules, and all known data breaches, cyber security breaches, fraud or suspected fraud during the relevant period.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Completer:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Submission date:", -1))
const _hoisted_10 = {
  key: 0,
  class: "col-12 declarations mt-4"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-circle" }, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "col-12 declarations mt-4"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-circle" }, null, -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.loadingContent && !_ctx.errorLoadingContent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", null, _toDisplayString(_ctx.completer), 1),
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", null, _toDisplayString(_ctx.$formatDateFullDate(new Date())), 1),
          (!_ctx.formPartAData.declarationDetails?.isPrincipal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createTextVNode(" To submit this compliance form, you must be a Principal. ")
              ]))
            : (!_ctx.formPartAData.declarationDetails?.hasTrustCoordinator)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createTextVNode(" To submit this compliance form, a Trust Coordinator must be assigned for this Practice. A Principal can assign themselves as a Trust Coordinator on the initial dashboard page. ")
                ]))
              : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}